import React from 'react';
const primaryTomos = [{
  grade: '1° Grado',
  title: 'The World Around Me',
  level: 'Pre-A1'
}, {
  grade: '2° Grado',
  title: 'My Daily Life',
  level: 'A1'
}, {
  grade: '3° Grado',
  title: 'Animals & Actions',
  level: 'A1'
}, {
  grade: '4° Grado',
  title: 'Routines & Places',
  level: 'A1-A2'
}, {
  grade: '5° Grado',
  title: 'My Community',
  level: 'A2'
}, {
  grade: '6°/7° Grado',
  title: 'The Modern World',
  level: 'A2'
}];
const secondaryTomos = [{
  grade: '1° Año',
  title: 'Welcome to Secondary',
  level: 'A2-B1'
}, {
  grade: '2° Año',
  title: 'The World We Live In',
  level: 'B1'
}, {
  grade: '3° Año',
  title: 'Connecting Worlds',
  level: 'B1-B2'
}, {
  grade: '4° Año',
  title: 'Global Challenges',
  level: 'B2'
}, {
  grade: '5° Año',
  title: 'Language & Society',
  level: 'B2-C1'
}, {
  grade: '6° Año',
  title: 'Into the Future',
  level: 'C1'
}];
const tomoIncludes = [{
  text: 'Planificación anual lista para el directivo',
  bold: false
}, {
  text: '4 unidades con todas las clases del año',
  bold: false
}, {
  text: 'Actividades listas para imprimir',
  bold: false
}, {
  text: 'Evaluaciones + rúbricas + autoevaluación',
  bold: false
}, {
  text: 'Solucionario completo',
  bold: true
}, {
  text: 'Alineado a NAP y diseños curriculares',
  bold: false
}];
function TomoCard({
  emoji,
  title,
  subtitle,
  tomos
}: {
  emoji: string;
  title: string;
  subtitle: string;
  tomos: typeof primaryTomos;
}) {
  return <div className="bg-black border border-[#FF6B00]/30 rounded-2xl p-5 sm:p-6" data-id="element-218">
      <h3 className="text-[#FF6B00] text-lg sm:text-xl font-black mb-1" data-id="element-219">
        {emoji} {title}
      </h3>
      <p className="text-gray-400 text-sm mb-4" data-id="element-220">{subtitle}</p>
      <div className="space-y-2" data-id="element-221">
        {tomos.map((tomo, i) => <div key={i} className="flex items-center gap-2.5 text-white text-sm sm:text-base" data-id="element-222">
            <span className="text-gray-500 text-xs font-mono w-4 text-right flex-shrink-0" data-id="element-223">
              {i + 1}
            </span>
            <div className="flex-1 min-w-0" data-id="element-224">
              <span className="font-semibold" data-id="element-225">{tomo.grade}:</span>
              <span className="text-gray-300" data-id="element-226"> {tomo.title}</span>
            </div>
            <span className="bg-[#FF6B00]/15 text-[#FF6B00] text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded-full border border-[#FF6B00]/30 flex-shrink-0" data-id="element-227">
              {tomo.level}
            </span>
          </div>)}
      </div>
    </div>;
}
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-12 sm:py-16 px-4" data-id="element-228">
      <div className="max-w-5xl mx-auto" data-id="element-229">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-230">
          Lo que <span className="text-[#FF6B00]" data-id="element-231">recibís</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-232">
          <TomoCard emoji="📘" title="PRIMARIA — 6 Tomos" subtitle="1° a 6° grado" tomos={primaryTomos} data-id="element-233" />
          <TomoCard emoji="📗" title="SECUNDARIA — 6 Tomos" subtitle="1° a 6° año" tomos={secondaryTomos} data-id="element-234" />
        </div>

        {/* What each tome includes */}
        <div className="bg-[#FF6B00]/5 border border-[#FF6B00]/30 rounded-2xl p-6 sm:p-8 text-center" data-id="element-235">
          <h3 className="text-[#FF6B00] text-lg sm:text-xl font-black mb-5" data-id="element-236">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2 max-w-2xl mx-auto" data-id="element-237">
            {tomoIncludes.map((item, i) => <div key={i} className="flex items-start gap-1.5 text-left" data-id="element-238">
                <span className="text-green-400 flex-shrink-0 text-sm" data-id="element-239">✅</span>
                <span className={`text-white text-xs sm:text-sm leading-snug ${item.bold ? 'font-bold text-[#FF6B00]' : ''}`} data-id="element-240">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}